const common = {
  nav_home: '首页',
  nav_services: '服务介绍',
  nav_guide: '使用指南',
  nav_verify: '链上查询',
  nav_hash_tools: '哈希工具',
  nav_user_center: '个人中心',
  nav_login: '登录 / 注册',
  lang_zh: '中文',
  lang_en: 'English',

  hero_badge: '基于 Polygon 区块链的可信存证平台',
  hero_title_line1: '链上权益',
  hero_title_line2: '可信存证',
  hero_subtitle: '让每一份创作、每一项权益都拥有不可篡改的链上证明',
  hero_subtitle_tags: '安全托管 · 随时提取 · 永久验证',
  hero_btn_register: '开始登记',
  hero_btn_verify: '链上查询',
  hero_stat_registered: '链上登记',
  hero_stat_security: '安全保障',
  hero_stat_verify: '全天验证',

  services_title: '服务价值',
  services_subtitle: '为您的数字权益提供全方位保护',
  service_1_title: '链上存证不可篡改',
  service_1_desc: '基于Polygon区块链,确保每一次登记永久存证,时间戳可验证',
  service_2_title: '多格式文件支持',
  service_2_desc: '支持图片、音频视频、文档等多种格式,文件哈希上链,原文件安全存储',
  service_3_title: '平台托管或自托管',
  service_3_desc: '提供安全托管服务,或直接转送至您的数字钱包,灵活可控',
  service_4_title: '公开可验证',
  service_4_desc: '任何人都可以通过查询页验证链上记录,无需平台介入',

  scenarios_title: '适用于多种权益存证场景',
  scenarios_subtitle: '无论您需要保护什么类型的权益,我们都能为您提供可靠的链上存证服务',
  scenario_1: '著作权/作品登记',
  scenario_2: '证书/证件存证',
  scenario_3: '藏品/资产证明',
  scenario_4: '授权协议存证',
  scenario_5: '个人声明/事实陈述',

  how_title: '三步完成链上存证',
  how_subtitle: '简单快捷的操作流程,让权益保护触手可及',
  how_step1_title: '上传文件',
  how_step1_subtitle: '计算哈希',
  how_step1_desc: '上传您需要存证的文件,系统自动计算文件哈希值,确保数据完整性',
  how_step2_title: '支付确认',
  how_step2_subtitle: '铸造NFT',
  how_step2_desc: '完成支付后,系统将在Polygon链上为您铸造专属NFT,永久记录权益信息',
  how_step3_title: '链上验证',
  how_step3_subtitle: '永久存证',
  how_step3_desc: '铸造完成后,任何人都可以通过区块链浏览器验证您的权益记录',

  compliance_title: '透明合规的服务承诺',
  compliance_subtitle: '我们致力于提供专业、可信、合规的区块链存证服务',
  compliance_1: '链上事实验证,永久可查',
  compliance_2: '不替用户存储原始文件(仅哈希)',
  compliance_3: '不提供法律确权或裁决',
  compliance_4: '符合区块链存证技术标准',
  compliance_notice_title: '重要声明',
  compliance_notice_desc: '本平台提供技术存证服务,不构成法律确权或政府备案。我们仅提供基于区块链技术的数据存证和验证服务,不对存证内容的真实性、合法性或权属关系做出任何判断或保证。如需法律效力认定,请咨询专业法律机构。',

  testimonial_label: '用户评价',
  testimonial_quote: '使用权链为我的摄影作品做了链上存证,查询验证非常方便。现在我的每一张作品都有了不可篡改的时间戳证明,让我在版权保护方面更有底气。',
  testimonial_name: '张丽',
  testimonial_role: '独立摄影师',
  testimonial_stat1_value: '10,000+',
  testimonial_stat1_label: '已登记NFT数量',
  testimonial_stat2_value: '5,000+',
  testimonial_stat2_label: '活跃用户数量',
  testimonial_stat3_value: '50,000+',
  testimonial_stat3_label: '链上交易数量',

  cta_title: '准备好保护您的数字权益了吗?',
  cta_subtitle: '立即开始使用权链,为您的作品、证书、资产建立不可篡改的链上证明',
  cta_btn_register: '立即开始登记',
  cta_btn_verify: '免费查询体验',
  cta_trust1_title: '安全可靠',
  cta_trust1_desc: '基于Polygon区块链',
  cta_trust2_title: '快速便捷',
  cta_trust2_desc: '3分钟完成登记',
  cta_trust3_title: '专业支持',
  cta_trust3_desc: '7×24小时在线服务',

  footer_desc: '基于区块链的NFT权益存证与验证服务平台,让每一次权益都有链上证明。',
  footer_services: '服务',
  footer_service_1: 'NFT登记',
  footer_service_2: '链上查询',
  footer_service_3: '权益提取',
  footer_service_4: '批量操作',
  footer_legal: '法律条款',
  footer_legal_1: '服务条款',
  footer_legal_2: '隐私政策',
  footer_legal_3: '合规声明',
  footer_legal_4: '免责声明',
  footer_contact: '联系我们',
  footer_contact_service: '在线客服',
  footer_contact_docs: '帮助文档',
  footer_copyright: '© 2024 RightChain. All rights reserved.',

  verify: {
    title: 'NFT 真伪验证',
    subtitle: '输入 NFT ID 或扫描二维码验证真伪',
    inputLabel: '请输入 NFT ID 或证书编号',
    inputPlaceholder: '请输入 NFT ID',
    verifyButton: '验证',
    scanQR: '扫描二维码',
    verifying: '验证中...',
    verified: '已验证',
    notFound: '未找到',
    error: '验证失败',
    errorFailed: '验证失败，请稍后重试',
    nftNotFound: '未找到该 NFT',
    tryAgain: '请检查 ID 后重试',
    infoTitle: '如何获取 NFT ID？',
    info1: '您可以在登记完成后收到的证书或邮件中找到 NFT ID',
    info2: '也可以在个人中心的登记记录中查看对应的 NFT ID',
    info3: '如有疑问，请联系平台客服获取帮助',
  },

  nftDetail: {
    title: 'NFT 详情',
    basicInfo: '基本信息',
    nftId: 'NFT ID',
    productName: '产品名称',
    category: '类别',
    registrationDate: '登记日期',
    status: '状态',
    description: '登记说明',
    ownerInfo: '所有者信息',
    ownerName: '所有者姓名',
    contactInfo: '联系方式',
    blockchainInfo: '区块链信息',
    contractAddress: '合约地址',
    tokenId: 'Token ID',
    network: '网络',
    viewOnBlockscout: '在 Blockscout 上查看',
    viewOnPolygonScan: '在 PolygonScan 上查看',
    queryMore: '查询更多',
    loading: '加载中...',
    notFound: '未找到该 NFT',
    backToHome: '返回首页',
  },

  registerNft: {
    title: '登记 NFT',
    steps: {
      basic: '基本信息',
      owner: '所有者信息',
      wallet: '钱包地址',
      payment: '支付',
      complete: '完成',
    },
    basicInfo: {
      title: '基本信息',
      subtitle: '请填写您要登记的物品基本信息',
      itemName: '物品名称',
      itemNamePlaceholder: '请输入物品名称',
      itemNameHint: '请填写真实准确的物品名称，便于后续查询和验证',
      category: '物品类别',
      categoryPlaceholder: '请选择类别',
      categories: {
        electronics: '电子产品',
        jewelry: '珠宝首饰',
        artwork: '艺术品',
        collectibles: '收藏品',
        documents: '重要文件',
        other: '其他',
      },
      description: '登记说明',
      descriptionPlaceholder: '请详细描述物品的特征、用途等信息',
      descriptionHint: '详细的描述有助于证明您的权益，建议不少于50字',
      fileType: '文件类型',
      fileTypeFile: '上传文件',
      fileTypeHash: '输入哈希值',
      uploadFile: '上传文件',
      uploadFileHint: '点击或拖拽文件到此处上传',
      supportedFormats: '支持 PNG、JPG、PDF、DOC、TXT 格式',
      fileSizeLimit: '文件大小不超过 10MB',
      uploading: '上传中...',
      fileUploaded: '上传成功',
      reselect: '重新选择',
      fileHash: '文件哈希值（SHA-256）',
      fileHashHint: '请输入文件的 SHA-256 哈希值，可使用哈希工具计算',
      uploadCover: '上传封面图（可选）',
      uploadCoverHint: '点击或拖拽封面图到此处上传',
      coverSizeLimit: '封面图大小不超过 5MB',
      coverUploaded: '封面上传成功',
      helpTitle: '登记须知',
      helpItem1: '请确保您是该文件的合法权益人，平台不对内容真实性负责',
      helpItem2: '文件哈希值将永久记录在区块链上，请确认文件内容无误',
      helpItem3: '登记完成后不可修改，请仔细核对所有信息',
      uploadPhotos: '上传照片',
      uploadHint: '最多上传 5 张照片，支持 JPG、PNG 格式',
      uploadButton: '点击上传',
      next: '下一步',
    },
    ownerInfo: {
      title: '所有者信息',
      subtitle: '请填写物品所有者的详细信息',
      currentUser: '当前用户',
      loading: '加载中...',
      noteLabel: '说明：',
      noteContent: '登记主体将自动关联到您的账户，所有权益归属于当前登录用户。',
      templateLabel: '声明模板参考：',
      templateContent: '本人确认对上传的登记事项拥有合法权益，并同意将其登记至区块链进行永久存证。本人承诺所提供信息真实有效，并承担相应法律责任。',
      useTemplate: '使用此模板',
      registrantInfo: '登记人信息（可选）',
      registrantInfoHint: '如需填写代理人或联系人信息，可在此填写',
      declaration: '权益声明（可选）',
      declarationPlaceholder: '请填写您对该登记事项的权益声明，说明您与该事项的关系及权益归属',
      fullName: '姓名',
      fullNamePlaceholder: '请输入完整姓名',
      idNumber: '身份证号',
      idNumberPlaceholder: '请输入身份证号码',
      phone: '联系电话',
      phonePlaceholder: '请输入手机号码',
      email: '电子邮箱',
      emailPlaceholder: '请输入邮箱地址',
      address: '联系地址',
      addressPlaceholder: '请输入详细地址',
      previous: '上一步',
      next: '下一步',
    },
    wallet: {
      title: '钱包地址',
      subtitle: '请提供您的区块链钱包地址用于接收 NFT',
      walletAddress: '钱包地址',
      walletAddressPlaceholder: '请输入 Polygon 钱包地址（0x...）',
      hint: '请确保地址正确，NFT 将发送到此地址',
      connectWallet: '连接钱包',
      walletConnected: '钱包已连接',
      previous: '上一步',
      next: '下一步',
    },
    payment: {
      title: '支付费用',
      subtitle: '请完成支付以继续登记流程',
      orderSummary: '订单摘要',
      registrationName: '登记名称',
      registrationType: '登记类型',
      custodyMethod: '托管方式',
      platformCustody: '平台托管',
      directTransfer: '直接转送',
      creator: '创作者',
      notFilled: '未填写',
      notSelected: '未选择',
      priceBreakdown: '费用明细',
      serviceFee: '平台服务费',
      free: '免费',
      totalAmount: '应付总额',
      paymentMethodLabel: '支付方式',
      supportedPayments: '支持的支付方式：',
      creditCard: '信用卡',
      debitCard: '借记卡',
      alipay: '支付宝',
      wechat: '微信支付',
      certificateType: '证书类型',
      chineseVersion: '中文版',
      chineseVersionDesc: '仅包含中文内容',
      englishVersion: '英文版',
      englishVersionDesc: '仅包含英文内容',
      termsLabel: '服务条款',
      agreeTerms: '我已阅读并同意 《服务条款》',
      agreePrivacy: '我已阅读并同意 《隐私政策》',
      agreeBlockchain: '我理解区块链登记的不可篡改性，并确认信息准确无误',
      securityTitle: '安全保障：',
      securityItem1: '• 所有支付信息均经过加密处理',
      securityItem2: '• 支持7天无理由退款（未铸造前）',
      securityItem3: '• 区块链存证永久有效，不收取年费',
      previous: '上一步',
      pay: '确认支付',
      processing: '处理中...',
      submitFailed: '提交失败',
      iKnow: '我知道了',
      agreeRequired: '请阅读并同意相关协议',
      uploadFileRequired: '提交失败，请先上传文件',
      registrationFee: '登记费',
      blockchainFee: '区块链费用',
      total: '总计',
      paymentMethod: '支付方式',
      crypto: '加密货币',
      cardNumber: '卡号',
      cardNumberPlaceholder: '请输入卡号',
      expiryDate: '有效期',
      expiryDatePlaceholder: 'MM/YY',
      cvv: 'CVV',
      cvvPlaceholder: '请输入 CVV',
      agree: '我已阅读并同意',
      terms: '服务条款',
      and: '和',
      privacy: '隐私政策',
    },
    complete: {
      title: '登记完成',
      subtitle: '恭喜！您的 NFT 已成功登记',
      success: '登记成功！',
      message: '您的物品已成功登记到区块链，NFT 已发送到您的钱包地址。',
      nftId: 'NFT 编号',
      txHash: '交易哈希',
      walletAddress: '钱包地址',
      viewOnBlockchain: '在区块链上查看',
      downloadCertificate: '下载证书',
      backToHome: '返回首页',
      viewMyNfts: '查看我的 NFT',
    },
    header: {
      userCenter: '用户中心',
    },
    help: {
      title: '需要帮助？',
      desc: '如果您在登记过程中遇到任何问题，请查看我们的帮助文档或联系客服。',
      viewDocs: '查看帮助文档',
      contactSupport: '联系客服',
    },
  },

  legal: {
    title: '法律信息',
    menuItems: {
      legal: '法律条款',
      terms: '服务条款',
      privacy: '隐私政策',
      compliance: '合规声明',
      disclaimer: '免责声明',
    },
    loading: '加载中...',
    error: '加载失败，请稍后重试',
    noContent: '暂无内容',
  },

  userCenter: {
    title: '用户中心',
    welcome: '欢迎回来',
    sidebar: {
      dashboard: '仪表板概述',
      registrations: '登记记录',
      withdrawals: '提取记录',
      orders: '订单和发票',
      notifications: '通知中心',
      settings: '账户设置',
      logout: '退出登录',
      uid: 'UID',
      user: '用户',
    },
    dashboard: {
      welcome: '欢迎回来!',
      uid: 'UID',
      loading: '加载中...',
      quickRegister: '快速登记',
      batchQuery: '批量查询',
      stats: {
        totalRegistrations: '登记总数',
        inCustody: '托管中数量',
        transferred: '已转出数量',
      },
      quickActions: {
        newRegistration: '新建登记',
        queryVerify: '查询验证',
        batchExport: '批量导出',
        accountSettings: '账户设置',
      },
      recentActivity: {
        title: '最近登记记录',
        viewAll: '查看全部',
        noRecords: '暂无登记记录',
      },
      usageTips: {
        title: '使用小贴士',
        tip1: '定期备份重要文件，确保数字资产安全',
        tip2: '使用平台托管功能，随时可以提取到个人钱包',
        tip3: '通过链上查询功能验证NFT的真实性和所有权',
      },
      developingFeature: '功能开发中...',
    },
    registrations: {
      title: '登记记录',
      subtitle: '查看和管理您的所有数字权益登记记录',
      newRegistration: '新建登记',
      filters: {
        all: '全部',
      },
      table: {
        registrationId: '登记编号',
        name: '名称',
        type: '类型',
        date: '日期',
        status: '状态',
        actions: '操作',
      },
      actions: {
        view: '查看',
        exportPdf: '导出PDF',
        withdraw: '提取',
      },
      noData: '暂无登记记录',
      noDataMessage: '没有找到符合条件的登记记录',
      viewAll: '查看全部',
      pagination: {
        showing: '显示第',
        to: '-',
        of: '条，共',
        records: '条记录',
        previous: '上一页',
        next: '下一页',
      },
    },
    withdrawals: {
      title: '提取记录',
      subtitle: '查看和管理您的NFT提取历史',
      filters: {
        all: '全部',
      },
      fields: {
        tokenId: 'Token ID',
        targetWallet: '目标钱包',
        chainHash: '链上HASH',
        transactionHash: '交易哈希:',
        copy: '复制',
      },
      viewDetails: '查看详情',
      noData: '暂无数据',
      noDataMessage: '没有找到符合条件的提取记录',
      viewAll: '查看全部',
      loading: '加载中...',
      detailModal: {
        title: '提取详情',
        nftName: 'NFT名称',
        withdrawalId: '提取编号',
        tokenId: 'Token ID',
        targetWallet: '目标钱包地址',
        withdrawalTime: '提取时间',
        gasFee: 'Gas费用',
        transactionHash: '交易哈希',
        status: '状态',
      },
    },
    notifications: {
      title: '通知中心',
      subtitle: '您有',
      unreadCount: '条未读通知',
      allRead: '所有通知已读',
      markAllRead: '全部标记为已读',
      stats: {
        all: '全部通知',
        unread: '未读',
      },
      filters: {
        type: '类型：',
        status: '状态：',
        all: '全部',
        unread: '未读',
        read: '已读',
      },
      actions: {
        markRead: '标记已读',
        delete: '删除',
      },
      badge: {
        new: '新',
      },
      noData: '暂无通知',
      noDataMessage: '没有符合条件的通知',
      loading: '加载中...',
      pagination: {
        previous: '上一页',
        next: '下一页',
      },
    },
    settings: {
      title: '账户设置',
      subtitle: '管理您的账户信息和偏好设置',
      tabs: {
        profile: '个人资料',
        security: '安全设置',
      },
      profile: {
        title: '个人资料',
        avatar: '头像',
        uploadAvatar: '上传头像',
        uploading: '上传中...',
        uploadHint: '支持 JPG、PNG 格式，文件大小不超过 2MB',
        username: '用户名',
        bio: '个人简介',
        bioCount: '字',
        save: '保存修改',
        saving: '保存中...',
      },
      security: {
        title: '安全设置',
        email: {
          title: '邮箱地址',
          change: '修改邮箱',
        },
        password: {
          title: '登录密码',
          subtitle: '定期修改密码可以提高账户安全性',
          change: '修改密码',
        },
      },
      passwordModal: {
        title: '修改密码',
        currentPassword: '当前密码',
        currentPasswordPlaceholder: '请输入当前密码',
        newPassword: '新密码',
        newPasswordPlaceholder: '请输入新密码',
        passwordHint: '密码长度至少8位，包含字母和数字',
        confirmPassword: '确认新密码',
        confirmPasswordPlaceholder: '请再次输入新密码',
        cancel: '取消',
        confirm: '确认修改',
        changing: '修改中...',
      },
      emailModal: {
        title: '修改邮箱',
        currentEmail: '当前邮箱',
        newEmail: '新邮箱',
        newEmailPlaceholder: '请输入新邮箱地址',
        verificationCode: '验证码',
        verificationCodePlaceholder: '请输入验证码',
        sendCode: '发送验证码',
        codeSent: '验证码已发送到您的新邮箱',
        cancel: '取消',
        confirm: '确认修改',
        changing: '修改中...',
      },
    },
    withdrawModal: {
      title: '提取NFT',
      withdrawInfo: '提取信息',
      fields: {
        name: '名称',
        tokenId: 'Token ID',
        registrationDate: '登记日期',
        targetWallet: '目标钱包地址',
        targetWalletPlaceholder: '目标钱包地址必须是polygon网络',
      },
      riskConfirmation: '风险确认',
      confirmations: {
        understand: '我理解NFT提取后将转移到指定钱包，平台将不再托管',
        irreversible: '我确认钱包地址正确无误，提取操作不可撤销',
      },
      warning: {
        title: '重要提示：',
        message: '请仔细核对钱包地址，NFT一旦转出将无法撤回。建议先进行小额测试或使用已验证的钱包地址。',
      },
      actions: {
        cancel: '取消',
        submit: '提交',
        submitting: '提交中...',
      },
      validation: {
        addressRequired: '请输入钱包地址',
        addressInvalid: '请输入有效的钱包地址（以0x开头的42位字符）',
      },
    },
  },
};

export default common;
